// extracted by mini-css-extract-plugin
module.exports = {"navIcon":"HamburgMenu_navIcon__5YNAk","open":"HamburgMenu_open__tW4rd"};